import { Component, Inject, OnDestroy, AfterViewInit, ViewChild } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { Table } from 'primeng/table';

export interface ChecklistNavigationData {
  checklistList: Array<{
    id: string;
    name: string;
    tfmTag?: string;
    rdsTag?: string;
    objectId: string;
    objectType?: string;
  }>;
  currentIndex: number;
}

@Component({
  selector: 'app-checklist-navigation-sheet',
  templateUrl: './checklist-navigation-sheet.component.html',
  styleUrls: ['./checklist-navigation-sheet.component.css']
})
export class ChecklistNavigationSheetComponent implements OnDestroy, AfterViewInit {
  @ViewChild(Table) table: Table;

  checklistList: any[];
  currentIndex: number;
  selectedChecklist: any;

  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: ChecklistNavigationData,
    private bottomSheetRef: MatBottomSheetRef<ChecklistNavigationSheetComponent>
  ) {
    this.checklistList = data.checklistList;
    this.currentIndex = data.currentIndex;

    // Set the currently selected checklist
    if (this.checklistList && this.checklistList.length > 0) {
      this.selectedChecklist = this.checklistList[this.currentIndex];
    }
  }

  ngAfterViewInit() {
    // Scroll to the current checklist row after view initialization
    setTimeout(() => {
      this.scrollToCurrentRow();
    }, 100);
  }

  ngOnDestroy() {
    // Ensure the bottom sheet is closed if it's still open
    if (this.bottomSheetRef) {
      this.bottomSheetRef.dismiss();
    }
  }

  onRowSelect(event: any) {
    const selectedIndex = this.checklistList.findIndex(c => c.id === event.data.id);
    // Close the bottom sheet immediately
    this.bottomSheetRef.dismiss(selectedIndex);
  }

  close() {
    this.bottomSheetRef.dismiss();
  }

  scrollToCurrentRow() {
    if (!this.table) {
      return;
    }

    // Get the current checklist
    const currentChecklist = this.checklistList[this.currentIndex];
    if (!currentChecklist) {
      return;
    }

    // Calculate which page the current checklist is on
    const rowsPerPage = this.table.rows || 10; // Default to 10 if not set
    const targetPage = Math.floor(this.currentIndex / rowsPerPage);

    // Navigate to the correct page first
    if (this.table.first !== targetPage * rowsPerPage) {
      this.table.first = targetPage * rowsPerPage;
    }

    // Wait for the page to render, then scroll to the row
    setTimeout(() => {
      const rowElement = document.querySelector(`[data-row-id="${currentChecklist.id}"]`);
      if (rowElement) {
        // Scroll the row into view with smooth behavior
        rowElement.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest'
        });
      }
    }, 150);
  }
}

